import React, { Component, createRef, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { emailEditorChange } from 'actions/template'
import { Parser, ProcessNodeDefinitions } from 'html-to-react'
import {
  setSections,
  setBackground,
  setTextAlign,
  selectSection,
  clickSection,
  pasteSnippet,
  removeSection,
  receiveTemplate,
  readThemeFromHtml,
  set,
  toggleDefaultValuesModal,
} from 'actions/template'
import Sortable from 'components/theme/Sortable'
// import VariablesDialog from 'components/TemplateForm/Variables/VariablesDialog'
import {
  MenuItem,
  Menu,
  withStyles,
  IconButton,
  Hidden,
  Grid,
  // FormControlLabel,
  // Switch,
} from '@material-ui/core'
import Button from 'components/theme/Button'
import {
  Add,
  DragIndicator,
  Edit,
  Image,
  Delete,
  ArrowDropDown,
  ArrowDropUp,
} from '@material-ui/icons'
import { CodeBraces } from 'mdi-material-ui'
import snippetObj from './snippetObj'
import { icons } from './Snippets/Snippets'
import { DropTarget } from 'react-dnd'
import Footer from './Footer'
import './styles.scss'
import classNames from 'classnames'
import MergeFieldsPreviewSelect from 'components/AddOrEditTaskPage/MergeFieldsPreviewSelect'
import Tooltip from 'components/theme/HelpTooltip'
import purple from '@material-ui/core/colors/purple'
import textObjFn from 'utils/textObjFn'
const Handlebars = require('handlebars')
const update = require('immutability-helper')

const snippets = Object.values(snippetObj)

const parser = new Parser()
var isValidNode = function () {
  return true
}

var processNodeDefinitions = new ProcessNodeDefinitions(React)
var preprocessingInstructions = [
  {
    shouldPreprocessNode: function (node) {
      return Boolean(node.name) && node.name === 'a'
    },
    preprocessNode: function (node) {
      node.attribs = { id: `preprocessed-${node.attribs.id}` }
    },
  },
]
var processingInstructions = [
  {
    // Anything else
    shouldProcessNode: function (node) {
      return true
    },
    processNode: processNodeDefinitions.processDefaultNode,
  },
]

const getBaseItemStyle = isActive => ({
  cursor: 'pointer',
  background: isActive ? 'rgb(234, 249, 255, .5)' : null,
  border: isActive ? 'dashed 2px #034c94' : null,
  padding: isActive ? 2 : undefined,
})
function sanitizeTemplate(template) {
  // Regular expression to match all Handlebars expressions {{ ... }}
  return template.replace(/{{([^}]*)}}/g, (match, expression) => {
    // Remove all &nbsp; entities within the expression
    const sanitizedExpression = expression.replace(/&nbsp;/g, '').trim()
    return `{{ ${sanitizedExpression} }}`
  })
}

const SortableItemUI = React.memo(
  ({
    disabled,
    isDragging,
    isSelected,
    isClicked,
    style,
    attributes,
    item,
    index,
    selectSection,
    clickSection,
    removeSection,
    moveUp,
    moveDown,
    ...props
  }) => {
    const ref = createRef()
    const [height, setHeight] = useState(undefined)

    useEffect(() => {
      const calculateHeight = () => setHeight(ref?.current?.clientHeight)
      const timeout = setTimeout(calculateHeight, 1000)
      return () => clearTimeout(timeout)
    }, [ref])

    const textObj = textObjFn({ ...props })

    const sanitizedValue = sanitizeTemplate(item.value || '')

    const text = Handlebars.compile(sanitizedValue)

    console.log('SortableItemUI render')
    console.log(item)
    return (
      <div
        id={item.id}
        key={item.id}
        ref={ref}
        {...attributes}
        style={{
          ...style,
          ...getBaseItemStyle(isSelected || isClicked),
          position: 'relative',
          padding: item?.editor === 'paragraph' ? 8 : 0,
        }}
        className={[
          'col-xs-6 col-sm-3 sortableItemInner',
          disabled && 'k-state-disabled',
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={() => !disabled && clickSection(index)}
      >
        <div
          style={isClicked ? { display: 'block' } : null}
          className="editButtons"
        >
          <IconButton
            onClick={e => {
              e.stopPropagation()
              !disabled && selectSection(index)
            }}
            style={{
              backgroundColor: '#000000a1',
              color: '#fff',
              marginLeft: 5,
              marginRight: 5,
            }}
          >
            <Edit style={{ color: '##fff' }} />
          </IconButton>
          <IconButton
            onClick={e => {
              e.stopPropagation()
              !disabled && removeSection(index)
            }}
            style={{
              backgroundColor: '#000000a1',
              color: '#fff',
              marginLeft: 5,
              marginRight: 5,
            }}
          >
            <Delete style={{ color: '##fff' }} />
          </IconButton>
          <IconButton
            onClick={e => {
              e.stopPropagation()
              !disabled && moveUp(index)
            }}
            style={{
              backgroundColor: '#000000a1',
              color: '#fff',
              marginLeft: 5,
              marginRight: 5,
            }}
          >
            <ArrowDropUp style={{ color: '##fff' }} />
          </IconButton>
          <IconButton
            onClick={e => {
              e.stopPropagation()
              !disabled && moveDown(index)
            }}
            style={{
              backgroundColor: '#000000a1',
              color: '#fff',
              marginLeft: 5,
              marginRight: 5,
            }}
          >
            <ArrowDropDown style={{ color: '##fff' }} />
          </IconButton>
        </div>
        {isDragging ? (
          <div style={{ height }}>
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                color: '#66a8e8',
                fontSize: 16,
                fontWeight: 'bold',
                backgroundColor: '#fff',
                zIndex: 100,
                padding: 10,
              }}
            >
              Drop Here
            </div>
            <div
              style={{
                height: 3,
                backgroundColor: '#66a8e8',
                position: 'absolute',
                width: '100%',
                top: '50%',
                transform: 'translate(0, -50%)',
              }}
            />
          </div>
        ) : (
          parser.parseWithInstructions(
            isSelected || !props.mergeFieldsPreviewSelectValue
              ? item.value
              : text(textObj),
            isValidNode,
            processingInstructions,
            preprocessingInstructions,
          )
        )}
      </div>
    )
  },
)

const SortableItem = connect(
  (state, { index }) => {
    const task = state.tasks.tasksByID[state.tasks.addOrEdit.taskID]
    const stats = task?.sms_stats || task?.email_stats
    const campaignStatus =
      state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
    const automationTypeSelected = state.tasks.addOrEdit.automationTypeSelected
    const disabled = Boolean(
      (stats && automationTypeSelected !== 'stage') ||
        campaignStatus === 'L' ||
        campaignStatus === 'C',
    )

    const mergeFieldsPreviewSelectValue =
      state.tasks.addOrEdit.mergeFieldsPreviewSelect?.value
    const contact =
      mergeFieldsPreviewSelectValue === 'sample'
        ? {
            id: 'sample',
            first_name: 'Jane',
            middle_name: 'Emily',
            last_name: 'Doe',
            email: [
              {
                id: 'sample-email',
                address: 'jane.doe@example.com',
                opt_in: true,
                email_type: 'W',
              },
            ],
            phones: [
              {
                id: 'sample-phone',
                number: '+19999999999',
                opt_in: true,
                phone_type: 'M',
              },
            ],
            location: 'Huntingdon Valley, PA',
            notes: 'Such a nice person!',
            vastuser: Object.keys(state.data?.['account/user'] || {})?.[0],
          }
        : state.contacts.contactsWithEmailsByID?.[mergeFieldsPreviewSelectValue]

    return {
      isSelected: state.email.sectionSelected === index,
      isClicked: state.email.sectionClicked === index,
      disabled,
      mergeFieldsPreviewSelectValue,
      contact,
      vastuser: state.data?.['account/user']?.[contact?.vastuser],
      preferences: state.data?.['account/preference']?.preferences,
      account: state.data?.account,
      assignedNumber: Object.values(state.data?.phonenumbers || {})?.find(
        numberObj => numberObj?.vast_user_name === contact?.vastuser,
      )?.phone_number,
      ...state.email.defaultValues,
    }
  },
  dispatch =>
    bindActionCreators(
      { removeSection, selectSection, clickSection, setSections },
      dispatch,
    ),
)(SortableItemUI)

const emptyItemUI = () => (
  <div style={{ padding: 10, color: 'gray' }}>
    Add a section to your new email template!
  </div>
)

class TemplateHtml extends Component {
  state = {
    anchorEl: null,
  }

  componentDidMount() {
    console.log('TemplateHtml componentDidMount()')

    this.props.set()
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  onDragOver = (dragIndex, hoverIndex) => {
    const { sections, setSections } = this.props
    const dragObj = sections[dragIndex]

    setSections(
      update(sections, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragObj],
        ],
      }),
    )
  }

  moveUp = index => {
    if (index !== 0) {
      const arr = this.props.sections
      ;[arr[index], arr[index - 1]] = [arr[index - 1], arr[index]]
      this.props.setSections(arr)
    }
  }

  moveDown = index => {
    const { sections } = this.props
    if (index !== sections.length - 1) {
      const arr = sections
      ;[arr[index], arr[index + 1]] = [arr[index + 1], arr[index]]
      this.props.setSections(arr)
    }
  }

  render() {
    const {
      sections,
      /* setSections, */ background,
      textAlign,
      disabled,
      modal,
      foreground,
      selectSection,
      classes,
      toggleDefaultValuesModal,
      preferences,
    } = this.props

    const { anchorEl } = this.state

    const dragHandle = () => (
      <DragIndicator className={classNames('dragHandle', classes.dragHandle)} />
    )

    const textObj = textObjFn({ preferences })

    let compiledBackground = ''
    let compiledForeground = ''
    let backgroundString = ''
    let foregroundString = ''

    try {
      compiledBackground = Handlebars.compile(background || '')
      backgroundString = compiledBackground(textObj)
    } catch (error) {
      console.log(error)
    }

    try {
      compiledForeground = Handlebars.compile(foreground || '')
      foregroundString = compiledForeground(textObj)
    } catch (error) {
      console.log(error)
    }

    // const compiledBackground = Handlebars.compile(background || '')
    // const compiledForeground = Handlebars.compile(foreground || '')

    // console.log('compiledBackground:', compiledBackground)
    // console.log('compiledForeground:', compiledForeground)
    // console.log('backgroundString:', backgroundString)
    // console.log('foregroundString:', foregroundString)
    // console.log(textObj)

    return (
      <>
        <div
          style={{
            // backgroundColor: '#014c94',
            textAlign,
            width: '100%',
            margin: 'auto',
            position: 'relative',
            overflow: 'hidden',
            // overflowY: 'visible',
          }}
        >
          {!disabled && (
            <div
              style={{
                padding: '13px 0',
                backgroundColor: '#014c94',
                position: 'relative',
              }}
            >
              <Grid container justify="space-between">
                <Grid item>
                  <Hidden smDown>
                    <div
                      style={{
                        minWidth: 185,
                        marginLeft: 40,
                        width: '18vw',
                        position: 'relative',
                      }}
                    >
                      <div
                        style={{
                          position: 'absolute',
                          left: -31,
                          top: '50%',
                          transform: 'translateY(-50%)',
                        }}
                      >
                        <Tooltip iconStyle={{ color: '#fff' }}>
                          Selecting a contact here will populate the merge
                          fields of this contact if applicable.
                        </Tooltip>
                      </div>
                      <MergeFieldsPreviewSelect />
                      {/* <div
                        style={{
                          position: 'absolute',
                          right: -20,
                          top: '50%',
                          transform: 'translateY(-50%)',
                        }}
                      >
                        <FormControlLabel
                          control={
                            <Switch
                              checked={false}
                              onChange={() => console.log('change')}
                              value="checkedA"
                              classes={{
                                switchBase: classes.colorSwitchBase,
                                checked: classes.colorChecked,
                                bar: classes.colorBar,
                              }}
                            />
                          }
                          label="Custom color"
                        />
                      </div> */}
                    </div>
                  </Hidden>
                </Grid>
                <Grid item>
                  <div style={{ textAlign: 'right' }}>
                    <IconButton
                      onClick={() => toggleDefaultValuesModal(true)}
                      style={{ color: '#fff' }}
                    >
                      <CodeBraces />
                    </IconButton>
                    <IconButton
                      onClick={() => selectSection('colors')}
                      style={{ color: '#fff' }}
                    >
                      <Image />
                    </IconButton>
                    <Button
                      aria-owns={anchorEl ? 'snippet-menu' : undefined}
                      aria-haspopup="true"
                      onClick={this.handleClick}
                      color="secondary"
                      style={{ marginRight: 10, color: '#fff' }}
                    >
                      <Add style={{ marginRight: 3, fontSize: 20 }} />
                      Add Section
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </div>
          )}
          <div
            className={modal ? 'absoluteBackgroundModal' : 'absoluteBackground'}
          >
            <div style={{ background: backgroundString }}>
              <div
                style={{
                  maxWidth: 600,
                  margin: '0 auto',
                  background: foregroundString,
                }}
              >
                <Sortable
                  className="zoomStyles"
                  idField={'id'}
                  data={sections}
                  itemUI={SortableItem}
                  dragHandle={dragHandle}
                  emptyItemUI={emptyItemUI}
                  moveUp={this.moveUp}
                  moveDown={this.moveDown}
                  // animation={true}
                  onDragOver={this.onDragOver}
                  // onNavigate={function (event) {
                  // 	if (!disabled && event.newState) {
                  // 		setSections(event.newState)
                  // 	}
                  // }}
                />
              </div>
            </div>
            <Footer />
          </div>
          <Menu
            id="snippet-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
          >
            {snippets.map(snippet => {
              return (
                <MenuItem
                  key={`snippetMenuItem-${snippet.text}`}
                  value={snippet}
                  onClick={() => {
                    this.props.pasteSnippet(snippet)
                    this.setState({ anchorEl: null })
                  }}
                >
                  {icons(snippet.icon)}
                  {snippet.text}
                </MenuItem>
              )
            })}
          </Menu>
        </div>
        {/* <VariablesDialog /> */}
      </>
    )
  }
}

const StyledTemplateHtml = withStyles(theme => ({
  dragHandle: {
    display: 'none',
  },
  colorSwitchBase: {
    color: purple[300],
    '&$colorChecked': {
      color: purple[500],
      '& + $colorBar': {
        backgroundColor: purple[500],
      },
    },
  },
  colorBar: {},
  colorChecked: {},
}))(TemplateHtml)

const BiggerComponent = DropTarget(
  'snippet',
  {
    drop: (props, monitor) => {
      props.onDrop(monitor.getItem())
    },
  },
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  }),
)(props =>
  props.connectDropTarget(
    <div style={props.isOver ? { border: '3px dashed #014c94' } : null}>
      <StyledTemplateHtml mobile {...props} />
    </div>,
  ),
)

const DndBiggerComponent = props => (
  <BiggerComponent
    {...props}
    onDrop={item => props.pasteSnippet(item.snippet)}
  />
)

export default connect(
  state => {
    const task = state.tasks.tasksByID[state.tasks.addOrEdit.taskID]
    const stats = task?.sms_stats || task?.email_stats
    const campaignStatus =
      state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
    const automationTypeSelected = state.tasks.addOrEdit.automationTypeSelected
    const disabled = Boolean(
      (stats && automationTypeSelected !== 'stage') ||
        campaignStatus === 'L' ||
        campaignStatus === 'C',
    )

    return {
      value: state.email.body.value,
      sections: state.email.sections,
      background: state.email.colors.background,
      foreground: state.email.colors.foreground,
      textAlign: state.email.textAlign,
      disabled,
      preferences: state.data?.['account/preference']?.preferences,
    }
  },
  dispatch =>
    bindActionCreators(
      {
        emailEditorChange,
        setSections,
        setBackground,
        setTextAlign,
        selectSection,
        pasteSnippet,
        receiveTemplate,
        readThemeFromHtml,
        set,
        toggleDefaultValuesModal,
      },
      dispatch,
    ),
)(DndBiggerComponent)
